import { Box, Container, Typography, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import BackToHome from './BackToHome';

const PrivacyPolicy = () => {
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <Box sx={{ py: 8, bgcolor: 'background.default' }}>
      <BackToHome />
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Paper elevation={0} sx={{ p: 4 }}>
            <Typography variant="h3" component="h1" gutterBottom color="primary" align="center">
              Privacy Policy
            </Typography>
            
            <Typography variant="body2" paragraph color="text.secondary">
              Effective Date: {currentDate}
            </Typography>

            <Typography variant="body1" paragraph>
              At GrowTaxBusiness.com, we value your privacy and are committed to protecting your personal information. 
              This Privacy Policy outlines the types of personal information we collect, how we use it, and the steps 
              we take to ensure its protection.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
              1. Information We Collect
            </Typography>
            <Typography variant="body1" paragraph>
              We collect personal information that you voluntarily provide when you:
            </Typography>
            <ul>
              <Typography component="li" variant="body1">Sign up for our tax prep business coaching program</Typography>
              <Typography component="li" variant="body1">Purchase our business packages</Typography>
              <Typography component="li" variant="body1">Contact us for support or inquiries</Typography>
              <Typography component="li" variant="body1">Subscribe to newsletters or communications</Typography>
            </ul>

            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
              2. How We Use Your Information
            </Typography>
            <Typography variant="body1" paragraph>
              Your information is used solely for:
            </Typography>
            <ul>
              <Typography component="li" variant="body1">Providing coaching services and resources</Typography>
              <Typography component="li" variant="body1">Processing payments and fulfilling orders</Typography>
              <Typography component="li" variant="body1">Communicating about your purchased services</Typography>
              <Typography component="li" variant="body1">Improving our services and customer experience</Typography>
            </ul>

            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
              3. Data Security
            </Typography>
            <Typography variant="body1" paragraph>
              We implement industry-standard security measures to protect your personal information. 
              However, no method of transmission over the Internet is 100% secure. While we strive 
              to protect your data, we cannot guarantee its absolute security.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
              4. Information Sharing
            </Typography>
            <Typography variant="body1" paragraph>
              We do not sell, trade, or rent your personal information to third parties. Information 
              may be shared with trusted service providers who assist in operating our business, such 
              as payment processors and email service providers.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
              5. Your Rights
            </Typography>
            <Typography variant="body1" paragraph>
              You have the right to:
            </Typography>
            <ul>
              <Typography component="li" variant="body1">Access your personal information</Typography>
              <Typography component="li" variant="body1">Request corrections to your data</Typography>
              <Typography component="li" variant="body1">Opt-out of marketing communications</Typography>
              <Typography component="li" variant="body1">Request data deletion (subject to legal requirements)</Typography>
            </ul>

            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
              6. Contact Information
            </Typography>
            <Typography variant="body1" paragraph>
              For privacy-related inquiries, please contact us at:
              <br />
              Email: growtaxbusiness@gmail.com
              <br />
              {/* Address: [Your Business Address] */}
            </Typography>

            <Typography variant="body2" sx={{ mt: 4 }} color="text.secondary">
              Last updated: {currentDate}
            </Typography>
          </Paper>
        </motion.div>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;
